export const CLIENTS_COUNT_REQUEST = 'CLIENTS_COUNT_REQUEST';
export const CLIENTS_COUNT_SUCCESS = 'CLIENTS_COUNT_SUCCESS';
export const CLIENTS_COUNT_FAILURE = 'CLIENTS_COUNT_FAILURE';
export const CLIENTS_DATA_REQUEST = 'CLIENTS_DATA_REQUEST';
export const CLIENTS_DATA_SUCCESS = 'CLIENTS_DATA_SUCCESS';
export const CLIENTS_DATA_FAILURE = 'CLIENTS_DATA_FAILURE';
export const FILTER_CLIENTS_DATA_REQUEST = 'FILTER_CLIENTS_DATA_REQUEST';
export const FILTER_CLIENT_DATA_SUCCESS = 'FILTER_CLIENT_DATA_SUCCESS';
export const FILTER_CLIENTS_DATA_FAILURE = 'FILTER_CLIENTS_DATA_FAILURE';
export const FILTER_LAST_VISIT = 'FILTER_LAST_VISIT';
export const FILTER_NEXT_VISIT = 'FILTER_NEXT_VISIT';
export const FILTER_SERVICES = 'FILTER_SERVICES';
export const FILTER_SELECTED_STYLISTS = 'FILTER_SELECTED_STYLISTS';
export const MARK_CLIENT_SELECT = 'MARK_CLIENT_SELECT';
export const SELECT_ALL_CLIENTS = 'SELECT_ALL_CLIENTS';
export const SHOW_HIDE_OPT_CLIENTS = 'SHOW_HIDE_OPT_CLIENTS';
export const SHOW_HIDE_NO_PHONE = 'SHOW_HIDE_NO_PHONE';
export const SET_SMS_MESSAGE = 'SET_SMS_MESSAGE';
export const SEND_MARKETING_SMS_REQUEST = 'SEND_MARKETING_SMS_REQUEST';
export const SEND_MARKETING_SMS_SUCCESS = 'SEND_MARKETING_SMS_SUCCESS';
export const SEND_MARKETING_SMS_FAILURE = 'SEND_MARKETING_SMS_FAILURE';
export const SET_MESSAGE_SENT = 'SET_MESSAGE_SENT';
export const SET_OPT_VALUE = 'SET_OPT_VALUE';
export const SET_HIDE_PHONE_VALUE = 'SET_HIDE_PHONE_VALUE';
export const SORT_CLIENT_LIST = 'SORT_CLIENT_LIST';
export const GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST = 'GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST';
export const GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS = 'GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS';
export const GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE = 'GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE';

export const GET_MARKETING_CAMPAIGNS_REQUEST = 'GET_MARKETING_CAMPAIGNS_REQUEST';
export const GET_MARKETING_CAMPAIGNS_SUCCESS = 'GET_MARKETING_CAMPAIGNS_SUCCESS';
export const GET_MARKETING_CAMPAIGNS_FAILURE = 'GET_MARKETING_CAMPAIGNS_FAILURE';
export const GET_MANUAL_MESSAGES_ONLY_REQUEST = 'GET_MANUAL_MESSAGES_ONLY_REQUEST';
export const GET_MANUAL_MESSAGES_ONLY_SUCCESS = 'GET_MANUAL_MESSAGES_ONLY_SUCCESS';
export const GET_MANUAL_MESSAGES_ONLY_FAILURE = 'GET_MANUAL_MESSAGES_ONLY_FAILURE';
export const GET_CAMPAIGN_CLIENTS_REQUEST = 'GET_CAMPAIGN_CLIENTS_REQUEST';
export const GET_CAMPAIGN_CLIENTS_SUCCESS = 'GET_CAMPAIGN_CLIENTS_SUCCESS';
export const GET_CAMPAIGN_CLIENTS_FAILURE = 'GET_CAMPAIGN_CLIENTS_FAILURE';
export const GET_CAMPAIGN_BOOKINGS_REQUEST = 'GET_CAMPAIGN_BOOKINGS_REQUEST';
export const GET_CAMPAIGN_BOOKINGS_SUCCESS = 'GET_CAMPAIGN_BOOKINGS_SUCCESS';
export const GET_CAMPAIGN_BOOKINGS_FAILURE = 'GET_CAMPAIGN_BOOKINGS_FAILURE';
export const SET_SHOW_CAMPAIGN_DETAILS = 'SET_SHOW_CAMPAIGN_DETAILS';
export const SORT_CAMPAIGN_LIST = 'SORT_CAMPAIGN_LIST';
export const SORT_CAMPAIGN_CLIENT_LIST = 'SORT_CAMPAIGN_CLIENT_LIST';

export const GET_AUTO_MESSAGES_REQUEST = 'GET_AUTO_MESSAGES_REQUEST';
export const GET_AUTO_MESSAGES_SUCCESS = 'GET_AUTO_MESSAGES_SUCCESS';
export const GET_AUTO_MESSAGES_FAILURE = 'GET_AUTO_MESSAGES_FAILURE';
export const SORT_AUTO_MSG_LIST = 'SORT_AUTO_MSG_LIST';
export const SET_SHOW_AUTOMSG_DETAILS = 'SET_SHOW_AUTOMSG_DETAILS';
export const SORT_AUTO_MSG_CLIENT_LIST = 'SORT_AUTO_MSG_CLIENT_LIST';
export const FILTER_TIME_RANGE = 'FILTER_TIME_RANGE';
export const SET_TIME_RANGE = 'SET_TIME_RANGE';
export const CLEAR_TIME_RANGE = 'CLEAR_TIME_RANGE';
export const BULK_OPTOUT_CLIENT_REQUEST = 'BULK_OPTOUT_CLIENT_REQUEST';
export const BULK_OPTOUT_CLIENT_SUCCESS = 'BULK_OPTOUT_CLIENT_SUCCESS';
export const BULK_OPTOUT_CLIENT_FAILURE = 'BULK_OPTOUT_CLIENT_FAILURE';
export const BULK_DELETE_CLIENT_REQUEST = 'BULK_DELETE_CLIENT_REQUEST';
export const BULK_DELETE_CLIENT_SUCCESS = 'BULK_DELETE_CLIENT_SUCCESS';
export const BULK_DELETE_CLIENT_FAILURE = 'BULK_DELETE_CLIENT_SUCCESS';
export const REST_BULK_DELETE_RESPONSE = 'REST_BULK_DELETE_RESPONSE';
export const FILTER_LOYALTY = 'FILTER_LOYALTY';
export const PURCHASE_SMS_BUNDLE_REQUEST = 'PURCHASE_SMS_BUNDLE_REQUEST';
export const PURCHASE_SMS_BUNDLE_SUCCESS = 'PURCHASE_SMS_BUNDLE_SUCCESS';
export const PURCHASE_SMS_BUNDLE_FAILURE = 'PURCHASE_SMS_BUNDLE_FAILURE';
export const SMS_CREDITS_PUSHER = 'SMS_CREDITS_PUSHER';
export const SET_AUTO_SMS_BY_MONTH = 'SET_AUTO_SMS_BY_MONTH';
export const SORT_AUTO_SMS_BY_MONTH = 'SORT_AUTO_SMS_BY_MONTH';

export const determineMarketingBucketList = (t) => [
  {
    id: 1,
    apiSuffix: 'withphone',
    title: t('marketing.card1Title'),
    description: t('marketing.card1Description'),
    question: t('marketing.card1Question'),
    image_url: 'marketing-all-clients.svg',
    information: t('marketing.card1Tooltip'),
  },
  {
    id: 2,
    apiSuffix: 'lost',
    title: t('marketing.card2Title'),
    description: t('marketing.card2Description'),
    question: t('marketing.card2Question'),
    image_url: 'marketing-lost-clients.svg',
    information: t('marketing.card2Tooltip'),
  },
  {
    id: 3,
    apiSuffix: 'cancelations',
    title: t('marketing.card3Title'),
    description: t('marketing.card3Description'),
    question: '',
    image_url: 'marketing-all-clients.svg',
    information: t('marketing.card3Tooltip'),
  },
  {
    id: 4,
    apiSuffix: 'invalid_patch_test',
    title: t('marketing.card4Title'),
    description: t('marketing.card4Description'),
    question: t('marketing.card4Question'),
    image_url: 'marketing-patch-test-clients.png',
    information: t('marketing.card4Tooltip'),
  },
  {
    id: 5,
    apiSuffix: 'first',
    title: t('marketing.card5Title'),
    description: t('marketing.card5Description'),
    question: t('marketing.card5Question'),
    image_url: 'marketing-new-clients.svg',
    information: t('marketing.card5Tooltip'),
  },
  {
    id: 6,
    apiSuffix: 'birthday',
    title: t('marketing.card6Title'),
    description: t('marketing.card6Description'),
    question: t('marketing.card6Question'),
    image_url: 'marketing-birthday.svg',
    information: t('marketing.card6Tooltip'),
  },
  {
    id: 7,
    apiSuffix: 'recent',
    title: t('marketing.card7Title'),
    description: t('marketing.card7Description'),
    question: t('marketing.card7Question'),
    image_url: 'marketing-review.svg',
    information: t('marketing.card7Tooltip'),
  },
  {
    id: 8,
    apiSuffix: 'upcoming',
    title: t('marketing.card8Title'),
    description: t('marketing.card8Description'),
    question: t('marketing.card8Question'),
    image_url: 'marketing-upcoming-clients.svg',
    information: t('marketing.card8Tooltip'),
  },
  {
    id: 9,
    apiSuffix: 'active',
    title: t('marketing.card9Title'),
    description: t('marketing.card9Description'),
    question: t('marketing.card9Question'),
    image_url: 'marketing-regular-clients.svg',
    information: t('marketing.card9Tooltip'),
  },
  {
    id: 10,
    apiSuffix: 'duplicates',
    title: t('marketing.card10Title'),
    description: t('marketing.card10Description'),
    question: t('marketing.card10Question'),
    image_url: 'marketing-all-clients.svg',
    information: t('marketing.card10Tooltip'),
  },
  {
    id: 11,
    apiSuffix: 'list',
    title: t('marketing.card11Title'),
    description: t('marketing.card11Description'),
    question: '',
    image_url: 'marketing-all-clients.svg',
    information: t('marketing.card11Tooltip'),
  },
];
